import script from "./AuthRoleTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthRoleTabs.vue?vue&type=script&setup=true&lang=js"

import "./AuthRoleTabs.vue?vue&type=style&index=0&id=9c8bf606&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c8bf606"]])

export default __exports__